<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Vacaciones del colaborador</h3>
  </div>
  <hr />

  <div class="d-grip gap-1 d-md-flex justify-content-md-end mb-5">
    <a [routerLink]="['/employees/list']" class="btn btn-outline-success">
      <i class="bi bi-arrow-left-circle"></i>
      Regresar a lista de colaboradores
    </a>
  </div>

  <div class="alert alert-success" role="alert" *ngIf="flagDeleted">
    {{ message }}
  </div>

  <div *ngIf="infoVacations.length == 0">
    <div class="alert alert-danger" role="alert">
      No hay vacaciones agendadas para el colaborador {{ employeeName }}
    </div>
  </div>
  <div *ngIf="infoVacations.length > 0">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Colaborador</th>
          <th>Fecha de Inicio</th>
          <th>Fecha de Fin</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let info of infoVacations
              | paginate : { itemsPerPage: 15, currentPage: page }
          "
        >
          <td>{{ employeeName }}</td>
          <td>{{ info.start_date }}</td>
          <td>{{ info.end_date }}</td>
          <td>
            <div class="d-flex d-flex-row">
              <div>
                <a
                  placement="top"
                  (click)="openDeleteVacation(info.id)"
                  role="button"
                  class="btn btn-primary"
                  ngbTooltip="Eliminar vacaciones del colaborador"
                >
                  <i class="bi bi-calendar2-x-fill"></i>
                </a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #deleteModalVacations let-close="close">
  <div class="modal-header">
    <h4 class="modal-title">
      Eliminar vacaciones de <strong>{{ employeeName }}</strong>
    </h4>
    <button class="close" type="button" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Deseas eliminar el periodo de vacaciones seleccionado?</p>
    <div class="row">
      <div class="d-grip gap-2 d-md-flex justify-content-md-end">
        <button
          class="btn btn-outline-success"
          (click)="deleteVacation(deletedId)"
          type="button"
        >
          Confirmar
        </button>
        <button class="btn btn-outline-danger" type="button" (click)="close()">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</ng-template>
